class BranchModel {
  constructor({
    branchId = null,
    branchName = "",
    companyId = null,
    referencedBranchId = null,
    createdAt = new Date(),
    updatedAt = new Date(),
    latitude = null,
    longitude = null,
    address = "",
    areaId = null,
  }) {
    this.branchId = branchId;
    this.branchName = branchName;
    this.companyId = companyId;
    this.referencedBranchId = referencedBranchId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.latitude = latitude;
    this.longitude = longitude;
    this.address = address;
    this.areaId = areaId;
  }
}

export default BranchModel;
